/**
 * @fileoverview added by tsickle
 * Generated from: src/firebase-remote-config-provider.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @license
 * Copyright DagonMetric. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found under the LICENSE file in the root directory of this source tree.
 */
import { NgModule } from '@angular/core';
import { CONFIG_PROVIDER } from '@dagonmetric/ng-config';
import { FirebaseRemoteConfigProvider } from './firebase-remote-config-provider';
import { FIREBASE_REMOTE_CONFIG_PROVIDER_OPTIONS } from './firebase-remote-config-provider-options';
/**
 * The `NGMODULE` for providing `FirebaseRemoteConfigProvider`.
 */
export class FirebaseRemoteConfigProviderModule {
    /**
     * Call this method to configure options for `FirebaseRemoteConfigProvider`.
     * @param {?} options An option object for `FirebaseRemoteConfigProvider`.
     * @return {?}
     */
    static configure(options) {
        return {
            ngModule: FirebaseRemoteConfigProviderModule,
            providers: [
                {
                    provide: FIREBASE_REMOTE_CONFIG_PROVIDER_OPTIONS,
                    useValue: options
                }
            ]
        };
    }
}
FirebaseRemoteConfigProviderModule.decorators = [
    { type: NgModule, args: [{
                providers: [
                    {
                        provide: CONFIG_PROVIDER,
                        useClass: FirebaseRemoteConfigProvider,
                        multi: true
                    }
                ]
            },] }
];
//# sourceMappingURL=firebase-remote-config-provider.module.js.map